<template>
  <v-dialog v-model="dialogLocal" persistent max-width="600px">
    <v-card>
      <v-card-title>
        <span class="headline">Create new premix</span>
      </v-card-title>
      <v-card-text>
        <vue-form :state="newPreMixinState" @submit.prevent="saveNewPreMixin">
          <v-container fluid grid-list-xl class="pt-0">
            <v-layout wrap align-top justify-end>
              <v-btn color="warning" flat @click="close">
                Close
              </v-btn>
              <v-btn type="submit" color="success">
                Save
              </v-btn>
            </v-layout>
          </v-container>
          <v-container grid-list-md class="pt-0">
            <v-layout wrap>
              <v-flex xs12>
                <validate>
                  <v-text-field
                    v-model="data.premixin.name"
                    required
                    label="Name"
                    name="name"
                    maxlength="40"
                    hide-details
                    counter
                    clearable
                  >
                  </v-text-field>
                  <field-messages
                    name="name"
                    show="$dirty && $touched || $submitted"
                  >
                    <small class="error--text" slot="required">
                      Name is a required field
                    </small>
                  </field-messages>
                </validate>
              </v-flex>
              <v-flex xs12>
                <validate>
                  <async-autocomplete
                    v-model="data.premixin.ingredients"
                    :items="ingredients"
                    name="ingredients"
                    label="Select ingredients"
                    item-text="name"
                    item-value="id"
                    return-object
                    multiple
                    required
                  />
                  <field-messages
                    name="ingredients"
                    show="$dirty && $touched || $submitted"
                  >
                    <small class="error--text" slot="required">
                      Ingredients is a
                      required field
                    </small>
                  </field-messages>
                </validate>
              </v-flex>
            </v-layout>
          </v-container>
        </vue-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import Premixes from '@/orm/models/Premixes';
import asyncAutocomplete from '@/components/form/asyncAutocomplete';

export default {
  name: 'newPreMixinPopup',
  props: {
    dialog: Boolean,
    ingredientsGroups: Array,
  },
  data() {
    return {
      data: {
        premixin: new Premixes(),
      },
      newPreMixinState: {},
    };
  },
  computed: {
    dialogLocal: {
      get() {
        return this.dialog;
      },
      set(val) {
        this.$emit('update:dialog', val);
      },
    },
    categories() {
      return this.ingredientsGroups
        .reduce((acc, group) => {
          const categories = group.categories.map(category => {
            category.groupId = group.id;
            return category;
          });
          acc = [
            ...acc,
            ...JSON.parse(JSON.stringify(categories)),
          ];
          return acc;
        }, []);
    },
    ingredients() {
      return this.categories
        .reduce((acc, cat) => {
          const ingredients = cat.ingredients.map(ingredient => {
            ingredient.groupId = cat.groupId;
            ingredient.categoryId = cat.id;
            ingredient.target = 0;
            ingredient.result = 0;
            return ingredient;
          });
          acc = [
            ...acc,
            ...JSON.parse(JSON.stringify(ingredients)),
          ];
          return acc;
        }, []);
    },
  },
  methods: {
    close() {
      this.data.premixin = new Premixes();
      this.newPreMixinState._reset();
      this.dialogLocal = false;
    },
    saveNewPreMixin() {
      if (!this.newPreMixinState.$valid) {
        return;
      }
      this.$emit('newPreMixin', this.data);
      this.close();
    },
  },
  components: {
    asyncAutocomplete,
  },
};
</script>
